import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import { Button } from '../components/ui/button';
import { Mail, CheckCircle } from 'lucide-react';

const JobSeekersPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Job Seekers - WorkNation Labour Ltd | Find Work in BC</title>
        <meta name="description" content="Looking for work in British Columbia? WorkNation Labour Ltd connects you with jobs in construction, warehouse, agriculture, transportation, cold storage. Flexible schedules, weekly pay. Register today." />
        <link rel="canonical" href="https://worknation.ca/job-seekers" />
      </Helmet>
      <Header />
      <main>
        <div className="pt-32 pb-20 px-6">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold text-[#003366] mb-6">Job Seekers &mdash; Find Work Across British Columbia</h1>
            <p className="text-lg text-gray-700 mb-10 leading-relaxed max-w-3xl">
              Looking for work? WorkNation Labour Ltd connects you with top employers across British Columbia. Work when you want, how you want. Jobs available in <strong>construction, warehouse, agriculture, transportation, and cold storage</strong>. Register today and start earning.
            </p>

            <div className="bg-gray-50 p-8 rounded-xl mb-12">
              <h2 className="text-3xl font-bold text-[#003366] mb-6">Opportunities Available</h2>
              <div className="grid md:grid-cols-2 gap-4">
                {[
                  'Construction labour and skilled trades',
                  'Warehouse picking, packing, and forklift work',
                  'Agricultural and farm positions',
                  'Transportation and driving roles',
                  'Cold storage and freezer work',
                  'Temporary, seasonal, and permanent positions',
                  'Flexible scheduling \u2014 days, evenings, weekends',
                  'Temp-to-perm pathways to full-time jobs',
                ].map((item, i) => (
                  <div key={i} className="flex items-start">
                    <CheckCircle className="text-green-500 mr-3 flex-shrink-0 mt-0.5" size={20} aria-hidden="true" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-12">
              <h2 className="text-2xl font-bold text-[#003366] mb-4">How to Get Started</h2>
              <ol className="space-y-3">
                {[
                  'Fill out the contact form below or email your resume to resumeworknation@gmail.com.',
                  'Our team reviews your qualifications, experience, and availability.',
                  'We match you with available positions that fit your skills and schedule.',
                  'Show up, work hard, and get paid. Perform well for ongoing opportunities.',
                ].map((step, i) => (
                  <li key={i} className="flex items-start">
                    <span className="flex-shrink-0 w-7 h-7 bg-[#003366] text-white rounded-full flex items-center justify-center font-bold mr-3 text-sm mt-0.5">{i + 1}</span>
                    <span className="text-gray-700">{step}</span>
                  </li>
                ))}
              </ol>
            </div>

            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#003366] mb-6 text-center">Register for Work</h2>
              <ContactForm type="jobseeker" />
            </div>

            <div className="text-center bg-gray-50 p-8 rounded-xl">
              <h3 className="text-2xl font-bold text-[#003366] mb-4">Send Your Resume</h3>
              <a href="mailto:resumeworknation@gmail.com" className="inline-block">
                <Button className="bg-[#003366] hover:bg-[#004488] text-white px-8 py-6 text-lg transition-all duration-300" data-testid="jobseeker-email-btn">
                  <Mail className="mr-2" size={20} />
                  resumeworknation@gmail.com
                </Button>
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default JobSeekersPage;
